// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Inter:100,200,300,regular,500,600,700,800,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

html {
  background: #e1d4c9;
  color: #403f3d;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

html,
button,
input,
select,
textarea {
  font-family: "Inter", sans-serif;
}

body {
  margin: 0;
}

a {
  background: transparent;
}
a:focus {
  outline: thin dotted;
}
a:hover, a:active {
  outline: 0;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

h2 {
  font-size: 1.5em;
  margin: 0.83em 0;
}

h3 {
  font-size: 1.17em;
  margin: 1em 0;
}

h4 {
  font-size: 1em;
  margin: 1.33em 0;
}

h5 {
  font-size: 0.83em;
  margin: 1.67em 0;
}

h6 {
  font-size: 0.75em;
  margin: 2.33em 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

mark {
  background: #ff0;
  color: #000;
}

code,
kbd,
pre,
samp {
  font-family: monospace, serif;
  font-size: 1em;
}

pre {
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word;
}

q {
  quotes: "“" "”" "‘" "’";
}

q:before, q:after {
  content: "";
  content: none;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 0;
}

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
  white-space: normal;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  margin: 0;
  vertical-align: baseline;
}

button,
input {
  line-height: normal;
}

button,
select {
  text-transform: none;
}

button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input[type=search] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}
input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}
input[type=checkbox], input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

html {
  scroll-behavior: smooth;
}

body {
  overflow-x: hidden;
}

.hidden {
  position: absolute;
  left: -99999em;
  width: 1px;
  height: 1px;
}

@media (max-width: 769px) {
  .hide-for-mobile {
    display: none !important;
  }
}

@media (min-width: 769px) {
  .hide-for-desktop {
    display: none !important;
  }
}

@media (max-width: 576px) {
  .hide-for-phones {
    display: none !important;
  }
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 0 40px;
  width: 100%;
}

h2 {
  margin: 0;
}

.section-visible {
  display: block;
  padding: 0 40px 100px 40px;
}
@media (max-width: 576px) {
  .section-visible {
    padding: 0 16px 100px 16px;
  }
}

.section-hidden {
  display: none;
}

li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.flex {
  display: flex;
}
.flex-fd-row {
  flex-direction: row;
}
.flex-fd-column {
  flex-direction: column;
}
.flex-fw-wrap {
  flex-wrap: wrap;
}
.flex-jc-center {
  justify-content: center;
}
.flex-jc-start {
  justify-content: flex-start;
}
.flex-jc-space-between {
  justify-content: space-between;
}
.flex-ai-center {
  align-items: center;
}
.flex-as-stretch {
  align-self: stretch;
}

.highlight {
  color: #b0907a;
  font-style: italic;
}

.small-text {
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 140%;
}

.title {
  font-size: 3.75rem;
  font-weight: 600;
  line-height: 125%;
}
@media (max-width: 576px) {
  .title {
    font-size: 2rem;
  }
}

.about_title {
  margin-top: 0;
  margin-bottom: 0;
}
@media (max-width: 992px) {
  .about_title {
    margin-bottom: 40px;
  }
}

.about_fotos_container {
  gap: 40px;
}
@media (max-width: 992px) {
  .about_fotos_container {
    flex-direction: column;
  }
}
.about_fotos_container .about-item_column {
  flex: 1;
  box-sizing: border-box;
}
.about_fotos_container .about-item_column .about-item_image {
  border-radius: 20px;
  margin-top: 38px;
  overflow: hidden;
}
@media (max-width: 992px) {
  .about_fotos_container .about-item_column .about-item_image {
    height: 590px;
    margin-top: 0;
  }
}
.about_fotos_container .about-item_column .about-item_image img {
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  transform: scale(1.2);
  transition: transform 0.6s ease;
}
@media (max-width: 576px) {
  .about_fotos_container .about-item_column .about-item_image img {
    width: -moz-max-content;
    width: max-content;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
.about_fotos_container .about-item_column .about-item_image:hover img {
  transform: scale(1);
  transition: transform 0.6s ease;
}

#image3 {
  height: 430px;
}

@media (max-width: 992px) {
  #second-image,
  #third-image {
    display: none;
  }
}

.header {
  padding: 0 40px 20px 40px;
}
@media (max-width: 576px) {
  .header {
    padding: 0 16px 20px 16px;
  }
}
.header__nav a {
  position: relative;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  line-height: 50%;
  color: #403f3d;
}
.header__links {
  padding: 0 0;
  gap: 40px;
  margin-top: 12px;
  margin-left: 8px;
}
.header__links a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #403f3d;
  transform: scaleX(0);
  transform-origin: 50% 50%;
  transition: transform 350ms ease;
}
.header__links a:hover::after {
  transform: scaleX(1);
  transform-origin: 50% 50%;
}
.header__menu {
  padding-right: 30px;
  margin-bottom: 4px;
}

.footer {
  margin: 0 40px;
  padding: 100px;
  border-radius: 40px;
  background: #665f55;
  color: #e1d4c9;
  gap: 100px;
}
@media (max-width: 992px) {
  .footer {
    flex-direction: column;
    align-items: flex-start;
    padding: 100px 60px;
    gap: 100px;
  }
}
@media (max-width: 576px) {
  .footer {
    margin: 0 16px;
    padding: 60px 16px;
    gap: 35px;
  }
}
.footer .footer__title {
  margin-bottom: 32px;
  max-width: 530px;
}
@media (max-width: 992px) {
  .footer .footer__title {
    margin-bottom: 40px;
  }
}
.footer .footer-social {
  flex-basis: 50% !important;
}
.footer .footer-icons__container {
  gap: 12px;
}
.footer .footer-contacts__title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 125%;
}
.footer .footer__list {
  padding: 0;
}
.footer .footer__item {
  position: relative;
  padding: 20px 0 0;
  border-bottom: 2px solid transparent;
}
.footer .footer__item img {
  padding-right: 4px;
}
.footer .footer__item a {
  -webkit-text-decoration: none;
  text-decoration: none;
  color: #e1d4c9;
}
.footer .footer__item a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 70%;
  height: 2px;
  background: #e1d4c9;
  transform: scaleX(0);
  transform-origin: 50% 50%;
  transition: transform 450ms ease;
}
.footer .footer__item a:hover::after {
  transform: scaleX(1);
  transform-origin: 50% 50%;
}

.start-screen {
  position: relative;
}
.start-screen_background {
  position: absolute;
  width: 100%;
  height: 644px;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 40px;
  z-index: -1;
}
@media (max-width: 769px) {
  .start-screen_background {
    height: 100%;
  }
}
.start-screen_content {
  padding: 100px 100px;
  max-width: 530px;
  color: #e1d4c9;
}
@media (max-width: 1200px) {
  .start-screen_content {
    padding: 100px 60px;
  }
}
@media (max-width: 576px) {
  .start-screen_content {
    padding: 60px 16px;
  }
}
.start-screen_content .start-screen_title {
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 106%;
}
@media (max-width: 576px) {
  .start-screen_content .start-screen_title {
    font-size: 2.625rem;
    line-height: 115%;
  }
}
.start-screen_content .start-screen_subtitle {
  font-weight: 400;
  line-height: 150%;
  padding: 23px 0 44px;
}

#favcoffee {
  position: relative;
  height: 50rem;
}
@media (max-width: 992px) {
  #favcoffee {
    height: 56rem;
  }
}
@media (max-width: 576px) {
  #favcoffee {
    height: 40rem;
  }
}

.favcoffee_title {
  text-align: center;
}

.mobile-app_container {
  gap: 100px;
}
@media (max-width: 1200px) {
  .mobile-app_container {
    flex-direction: column;
    gap: 90px;
  }
}
@media (max-width: 576px) {
  .mobile-app_container {
    gap: 30px;
  }
}
.mobile-app_container .mobile-app_offer {
  gap: 40px;
  margin-bottom: 12px;
}
.mobile-app_container .mobile-app_offer .mobile-app_title {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0px;
}
.mobile-app_container .mobile-app_offer .mobile-app_subtitle {
  font-weight: 400;
  line-height: 150%;
  padding-top: 0px;
  margin: 0;
}
.mobile-app_container .mobile-app_offer .mobile-app_buttons {
  gap: 20px;
  padding-top: 0px;
}
@media (max-width: 576px) {
  .mobile-app_container .mobile-app_offer .mobile-app_buttons {
    flex-direction: column;
  }
}
@media (max-width: 576px) {
  .mobile-app_container .mobile-app_screens img {
    width: 348px;
  }
}

.menu_card-container {
  gap: 37px;
}
@media (max-width: 769px) {
  .menu_card-container {
    padding-bottom: 40px;
  }
}

.menu_title {
  margin: 0 290px;
  text-align: center;
}
@media (max-width: 1200px) {
  .menu_title {
    margin: 0;
  }
}

.menu_tabs {
  gap: 16px;
  padding: 40px 0;
}

.menu_card {
  width: 310px;
  height: 467px;
  flex-shrink: 0;
  padding-bottom: 40px;
  border-radius: 40px;
  border: 1px solid #c1b6ad;
}
.menu_card_img {
  border-radius: 40px;
  overflow: hidden;
}
.menu_card img {
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  transform: scale(1.1);
  transition: transform 0.6s ease;
}
.menu_card:hover img {
  transform: scale(1);
  transition: transform 0.6s ease;
}
.menu_card .menu_card_content {
  position: relative;
  padding: 20px;
}
.menu_card .menu_card_content .menu_card_title {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 110%;
  margin: 0;
}
.menu_card .menu_card_content .menu_card_description {
  line-height: 150%;
  margin-top: 12px;
  margin-bottom: 0;
}
.menu_card .menu_card_content .menu_card_price {
  position: absolute;
  top: 120px;
  left: 20px;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 125%;
}

@media (max-width: 992px) {
  #coffee5,
  #coffee6,
  #coffee7,
  #coffee8 {
    display: none;
  }
}

.btn-primary {
  cursor: pointer;
  position: relative;
  width: 200px;
  padding: 22px 78px;
  border-radius: 100px;
  background: #e1d4c9;
  color: #403f3d;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-weight: 600;
  line-height: 150%;
}
.btn-primary .start-screen_icon {
  position: absolute;
  right: 26%;
  top: 50%;
  transform: translateY(-50%);
  display: none;
}
@media (max-width: 769px) {
  .btn-primary .start-screen_icon {
    display: block;
  }
}
.btn-primary:hover .start-screen_icon {
  display: block;
}

.btn__arrow, .btn-icon-light, .btn__refresh {
  cursor: pointer;
  border: 1px solid #665f55;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
@media (hover: hover) {
  .btn__arrow:hover, .btn-icon-light:hover, .btn__refresh:hover {
    background-color: #665f55;
    color: #e1d4c9;
    transition: background-color 0.5s ease-in-out;
  }
}

.btn__refresh {
  font-size: 1.4rem;
  font-weight: 200;
  margin: 0 auto;
}

.btn-app-store,
.btn-google-play {
  cursor: pointer;
  width: 160px;
  padding: 8px 19px;
  align-items: center;
  border: 1px solid #665f55;
  color: #403f3d;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-weight: 600;
  line-height: 140%;
  border-radius: 100px;
}
.btn-app-store .btn_icon,
.btn-google-play .btn_icon {
  width: 36px;
  height: 36px;
  margin-right: 8px;
  fill: #403f3d;
}
@media (hover: hover) {
  .btn-app-store:hover,
  .btn-google-play:hover {
    background-color: #665f55;
    color: #e1d4c9;
    transition: background-color 0.6s ease-in-out;
  }
  .btn-app-store:hover .btn_icon,
  .btn-google-play:hover .btn_icon {
    fill: #e1d4c9;
  }
}

.btn-icon-light {
  cursor: pointer;
  border-color: #c1b6ad;
}
@media (hover: hover) {
  .btn-icon-light:hover {
    background-color: #e1d4c9;
    color: #403f3d;
    transition: background-color 0.5s ease-in-out;
  }
  .btn-icon-light:hover img {
    filter: invert(1);
  }
}

.tab-item {
  cursor: pointer;
  display: inline-flex;
  flex-direction: row-reverse;
  padding: 8px 16px 8px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid #c1b6ad;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-weight: 600;
  line-height: 150%;
  color: #403f3d;
  background-color: #e1d4c9;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.tab-item img {
  border-radius: 100px;
  border: 1px solid #c1b6ad;
  padding: 3px;
  background-color: #c1b6ad;
}
.tab-item:hover {
  background-color: #665f55;
  color: #e1d4c9;
  transition: background-color 0.5s ease-in-out;
}
.tab-item-active {
  background-color: #665f55;
  color: #e1d4c9;
}
.tab-item-inactive {
  background-color: #fff;
}

.link-with-icon {
  cursor: pointer;
  position: relative;
  display: inline-block;
  background-color: #e1d4c9;
  border: 1px solid transparent;
  font-weight: 600;
  line-height: 150%;
  color: #403f3d;
}
.link-with-icon::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #403f3d;
  transform: scaleX(0);
  transform-origin: 50% 50%;
  transition: transform 350ms ease;
}
.link-with-icon:hover::after {
  transform: scaleX(1);
  transform-origin: 50% 50%;
}

.icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.header__burger {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border: 1px solid #665f55;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}
.header__burger span {
  display: block;
  position: absolute;
  transition: transform 0.3s ease;
  width: 16px;
  height: 2px;
  background-color: #403f3d;
  transition: transform 2s ease-in-out, top 2s ease-in-out, left 2s ease-in-out;
}
.header__burger span:first-child {
  top: 4px;
  left: -8px;
}
.header__burger span:last-child {
  bottom: 4px;
  left: -8px;
}

.carousel {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  text-align: center;
  transform: translate(-50%, -50%);
}
.carousel .slides-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slide-container {
  display: none;
  position: relative;
  margin: 0 auto;
  width: 480px;
  overflow: hidden;
  animation: 1s ease-in-out;
}
.slide-container img {
  max-width: 480px;
}
@media (max-width: 576px) {
  .slide-container img {
    margin: 0 auto;
    width: 348px;
  }
}
.slide-container .slide-content h3 {
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  padding-top: 61px;
  margin: 0px;
}
.slide-container .slide-content .slide-description {
  text-align: center;
  padding-top: 15px;
  line-height: 150%;
  margin: 0;
}
.slide-container .slide-content .slide-price {
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  padding-top: 17px;
  margin: 0px;
}
.slide-container.active, .slide-container.next {
  display: block;
}
.slide-container.next {
  position: absolute;
  top: 0;
  width: 100%;
}

.horizontal-line {
  width: 40px;
  height: 4px;
  background-color: #c1b6ad;
  margin: 39px 6px 0 6px;
}

.horizontal-line-active {
  background-color: #403f3d;
  animation: anim 7s ease 0s 1 normal forwards;
}

@keyframes anim {
  0% {
    transform: scaleX(0);
    transform-origin: 0% 0%;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
  }
}
.animate_to-left {
  animation-name: scrollToLeft;
}

.animate_to-right {
  animation-name: scrollToRight;
  animation-direction: reverse;
}

.animate_from-left {
  animation-name: scrollToLeft;
  animation-direction: reverse;
}

.animate_from-right {
  animation-name: scrollToRight;
}

@keyframes scrollToLeft {
  from {
    left: 0;
  }
  to {
    left: -100%;
  }
}
@keyframes scrollToRight {
  from {
    left: 100%;
  }
  to {
    left: 0;
  }
}
.mobile__nav {
  position: fixed;
  margin-top: 20px;
  padding: 60px 0px;
  top: 78px;
  left: 100%;
  width: 100%;
  min-height: 100vh;
  display: block;
  z-index: 5;
  background-color: #e1d4c9;
  transition: 2s;
}
.mobile__nav ul {
  margin: 0;
  padding: 0;
  gap: 60px;
}
.mobile__nav ul a {
  position: relative;
  margin-top: 40px;
  width: 140px;
}
.mobile__nav ul a img {
  position: absolute;
  top: -2px;
  width: 30%;
  padding-left: 14px;
}
.mobile__nav a {
  -webkit-text-decoration: none;
  text-decoration: none;
  color: #403f3d;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
}
.mobile__nav a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #403f3d;
  transform: scaleX(0);
  transform-origin: 50% 50%;
  transition: transform 350ms ease;
}
@media (hover: hover) {
  .mobile__nav a:hover::after {
    transform: scaleX(1);
    transform-origin: 50% 50%;
  }
}
.mobile__nav-active {
  left: 8px;
}
.mobile__btn-active span:first-child {
  transform: translateY(-5px) rotate(45deg);
  transition: transform 2s ease-in-out, top 2s ease-in-out, left 2s ease-in-out;
}
.mobile__btn-active span:last-child {
  transform: translateY(5px) rotate(-45deg);
  transition: transform 2s ease-in-out, top 2s ease-in-out, left 2s ease-in-out;
}

.modal {
  z-index: 10;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.75);
}
.modal-container {
  position: fixed;
  margin: 0 auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 48rem;
  padding: 1rem;
  border-radius: 2.5rem;
  background-color: #e1d4c9;
}
.modal-image {
  width: 19.35rem;
  flex-shrink: 0;
  border-radius: 2.5rem;
}
.modal-content {
  padding-left: 1.25rem;
  align-items: flex-start;
}
.modal-content p {
  margin-top: 0;
}
.modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 125%;
  margin: 0 0 0.7rem 0;
}
.modal-description {
  line-height: 150%;
  margin-bottom: 1.35rem;
}
.modal-label {
  margin-bottom: 0.6rem;
}
.modal-label-total {
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  margin-top: 0;
  margin-bottom: 0.9rem;
}
.modal-total-wrapper {
  width: 100%;
}
.modal-line {
  border-top: 1px solid #c1b6ad;
  padding: 0.75rem 0;
}
.modal-info-text {
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}
.modal-icon {
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  padding: 3px;
  justify-content: center;
  align-items: center;
  background-color: #c1b6ad;
  border: 1px solid #c1b6ad;
}
.modal-buttons-group {
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}
.modal-buttons-group button {
  padding-right: 0.8rem;
}
.modal-info-icon {
  padding-right: 0.5rem;
}
.modal-close-button {
  width: 100%;
  padding: 10px 78px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 1px solid #665f55;
  background-color: #e1d4c9;
  margin-top: 0.8rem;
}
@media (hover: hover) {
  .modal-close-button:hover {
    background-color: #665f55;
    color: #e1d4c9;
    transition: background-color 0.5s ease-in-out;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/style/base/_normalize.scss","webpack://./src/style/abstracts/_variables.scss","webpack://./src/style/base/_helpers.scss","webpack://./src/style/abstracts/_mixins.scss","webpack://./src/style/layout/_about.scss","webpack://./src/style/layout/_header.scss","webpack://./src/style/layout/_footer.scss","webpack://./src/style/layout/_startscreen.scss","webpack://./src/style/layout/_favcoffee.scss","webpack://./src/style/layout/_mobileapp.scss","webpack://./src/style/layout/_menu.scss","webpack://./src/style/components/_buttons.scss","webpack://./src/style/components/_slider.scss","webpack://./src/style/components/_burgermenu.scss","webpack://./src/style/components/_modal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC0ChB;;;;;;;;;;;EAWE,cAAA;ADvCF;;AC4CA;;;EAGE,qBAAA;ADzCF;;ACmDA;EACE,aAAA;EACA,SAAA;ADhDF;;ACwDA;;EAEE,aAAA;ADrDF;;ACiEA;EAIE,mBCxFc;EDyFd,cClGgB;EDmGhB,8BAAA;EACA,0BAAA;ADjEF;;ACsEA;;;;;EAKE,gCAjGuB;AD8BzB;;ACwEA;EACE,SAAA;ADrEF;;ACiFA;EAGE,uBAAA;ADhFF;ACoFE;EACE,oBAAA;ADlFJ;ACuFE;EAEE,UAAA;ADtFJ;;ACkGE;EACE,cA3IW;EA4IX,gBArIQ;ADsCZ;;ACkGE;EACE,gBA/IW;EAgJX,gBAzIQ;AD0CZ;;ACkGE;EACE,iBAnJW;EAoJX,aA7IQ;AD8CZ;;ACkGE;EACE,cAvJW;EAwJX,gBAjJQ;ADkDZ;;ACkGE;EACE,iBA3JW;EA4JX,gBArJQ;ADsDZ;;ACkGE;EACE,iBA/JW;EAgKX,gBAzJQ;AD0DZ;;ACqGA;EACE,yBAAA;ADlGF;;ACuGA;;EAEE,iBAAA;ADpGF;;AC+GA;EACE,kBAAA;AD5GF;;ACiHA;EACE,gBAAA;EACA,WAAA;AD9GF;;AC4HA;;;;EAIE,6BAAA;EAIA,cAAA;AD5HF;;ACiIA;EACE,gBAAA;EACA,qBAAA;EACA,qBAAA;AD9HF;;ACmIA;EACE,uBAAA;ADhIF;;AC+IE;EAEE,WAAA;EACA,aAAA;AD7IJ;;ACmJA;EACE,cAAA;ADhJF;;ACsJA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADnJF;;ACsJA;EACE,WAAA;ADnJF;;ACsJA;EACE,eAAA;ADnJF;;ACsMA;EACE,SAAA;ADnMF;;AC2MA;EACE,gBAAA;ADxMF;;ACiNA;EACE,SAAA;AD9MF;;AC8NA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;AD3NF;;ACmOA;EACE,SAAA;EACA,UAAA;EACA,mBAAA;ADhOF;;AC2OA;;;;EAIE,oBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;ADxOF;;ACgPA;;EAEE,mBAAA;AD7OF;;ACqPA;;EAEE,oBAAA;ADlPF;;AC6PA;;;;EAIE,0BAAA;EACA,eAAA;AD1PF;;ACkQA;;EAEE,eAAA;AD/PF;;ACuQE;;EACE,SAAA;EACA,UAAA;ADnQJ;;AC0QA;EACE,cAAA;EACA,mBAAA;ADvQF;;ACgRA;EACE,yBAAA;EACA,iBAAA;AD7QF;;ACmRE;EACE,6BAAA;EAGA,uBAAA;ADhRJ;ACoRI;EAEE,wBAAA;ADnRN;AC2RE;EAEE,sBAAA;EACA,UAAA;AD1RJ;;AG7OA;EACE,uBAAA;AHgPF;;AG7OA;EACE,kBAAA;AHgPF;;AG7OA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AHgPF;;AIlOE;EDXF;IAEI,wBAAA;EHgPF;AACF;;AI9OE;EDCF;IAEI,wBAAA;EHgPF;AACF;;AI9OE;EDCF;IAEI,wBAAA;EHgPF;AACF;;AG5OA;EACE,iBDRU;ECSV,cAAA;EACA,oBAAA;EACA,WAAA;AH+OF;;AG5OA;EACE,SAAA;AH+OF;;AG5OA;EACE,cAAA;EACA,0BAAA;AH+OF;AIpQE;EDmBF;IAII,0BAAA;EHiPF;AACF;;AG9OA;EACE,aAAA;AHiPF;;AG9OA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AHiPF;;AG9OA;EACE,aAAA;AHiPF;AG/OE;EACE,mBAAA;AHiPJ;AG/OE;EACE,sBAAA;AHiPJ;AG/OE;EACE,eAAA;AHiPJ;AG/OE;EACE,uBAAA;AHiPJ;AG/OE;EACE,2BAAA;AHiPJ;AG/OE;EACE,8BAAA;AHiPJ;AG/OE;EACE,mBAAA;AHiPJ;AG/OE;EACE,mBAAA;AHiPJ;;AG7OA;EACE,cDrFkB;ECsFlB,kBAAA;AHgPF;;AG7OA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AHgPF;;AG7OA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AHgPF;AIhUE;ED6EF;IAMI,eAAA;EHiPF;AACF;;AK/VA;EACE,aAAA;EACA,gBAAA;ALkWF;AI1UE;EC1BF;IAKI,mBAAA;ELmWF;AACF;;AKhWA;EACE,SAAA;ALmWF;AInVE;ECjBF;IAII,sBAAA;ELoWF;AACF;AKlWE;EACE,OAAA;EACA,sBAAA;ALoWJ;AKnWI;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;ALqWN;AIjWE;ECPE;IAMI,aAAA;IACA,aAAA;ELsWN;AACF;AKlWM;EACE,WAAA;EACA,oBAAA;KAAA,iBAAA;EACA,qBAAA;EACA,+BAAA;ALoWR;AI7WE;ECKI;IAMI,uBAAA;IAAA,kBAAA;IACA,gBAAA;IACA,2BAAA;ELsWR;AACF;AKpWM;EACE,mBAAA;EACA,+BAAA;ALsWR;;AKjWA;EACE,aAAA;ALoWF;;AI5XE;EC2BF;;IAGI,aAAA;ELoWF;AACF;;AM7ZA;EACE,yBAAA;ANgaF;AIvYE;EE1BF;IAII,yBAAA;ENiaF;AACF;AM9ZI;EACE,kBAAA;EACA,6BAAA;EAAA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cJZY;AF4alB;AM7ZE;EACE,YAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AN+ZJ;AM7ZI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBJ5BY;EI6BZ,oBAAA;EACA,yBAAA;EACA,gCAAA;AN+ZN;AM5ZI;EACE,oBAAA;EACA,yBAAA;AN8ZN;AM3ZE;EACE,mBAAA;EACA,kBAAA;AN6ZJ;;AOxcA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,mBLUmB;EKTnB,cAAA;EACA,UAAA;AP2cF;AIvbE;EG1BF;IASI,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,UAAA;EP4cF;AACF;AI/bE;EG1BF;IAeI,cAAA;IACA,kBAAA;IACA,SAAA;EP8cF;AACF;AO5cE;EACE,mBAAA;EACA,gBAAA;AP8cJ;AI1cE;EGNA;IAII,mBAAA;EPgdJ;AACF;AO7cE;EACE,0BAAA;AP+cJ;AO5cE;EACE,SAAA;AP8cJ;AO3cE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AP6cJ;AO1cE;EACE,UAAA;AP4cJ;AOzcE;EACE,kBAAA;EACA,iBAAA;EACA,oCAAA;AP2cJ;AO1cI;EACE,kBAAA;AP4cN;AO1cI;EACE,6BAAA;EAAA,qBAAA;EACA,cLnDa;AF+fnB;AO3cM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mBL3DW;EK4DX,oBAAA;EACA,yBAAA;EACA,gCAAA;AP6cR;AO1cM;EACE,oBAAA;EACA,yBAAA;AP4cR;;AQphBA;EACE,kBAAA;ARuhBF;AQthBE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;KAAA,iBAAA;EACA,mBAAA;EACA,WAAA;ARwhBJ;AItgBE;EIxBA;IASI,YAAA;ERyhBJ;AACF;AQvhBE;EACE,oBAAA;EACA,gBAAA;EACA,cNZe;AFqiBnB;AIhhBE;EIZA;IAMI,mBAAA;ER0hBJ;AACF;AIrhBE;EIZA;IASI,kBAAA;ER4hBJ;AACF;AQ1hBI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AR4hBN;AIhiBE;EIAE;IAOI,mBAAA;IACA,iBAAA;ER6hBN;AACF;AQ3hBI;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;AR6hBN;;ASrkBA;EACE,kBAAA;EACA,aAAA;ATwkBF;AIhjBE;EK1BF;IAKI,aAAA;ETykBF;AACF;AIrjBE;EK1BF;IAQI,aAAA;ET2kBF;AACF;;ASxkBA;EACE,kBAAA;AT2kBF;;AUxlBA;EACE,UAAA;AV2lBF;AIlkBE;EM1BF;IAII,sBAAA;IACA,SAAA;EV4lBF;AACF;AIxkBE;EM1BF;IAQI,SAAA;EV8lBF;AACF;AU5lBE;EACE,SAAA;EACA,mBAAA;AV8lBJ;AU7lBI;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AV+lBN;AU7lBI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AV+lBN;AU7lBI;EACE,SAAA;EACA,gBAAA;AV+lBN;AIhmBE;EMDE;IAKI,sBAAA;EVgmBN;AACF;AIrmBE;EMUE;IAEI,YAAA;EV6lBN;AACF;;AWpoBA;EACE,SAAA;AXuoBF;AI9mBE;EO1BF;IAII,oBAAA;EXwoBF;AACF;;AWroBA;EACE,eAAA;EACA,kBAAA;AXwoBF;AIxnBE;EOlBF;IAKI,SAAA;EXyoBF;AACF;;AWtoBA;EACE,SAAA;EACA,eAAA;AXyoBF;;AWtoBA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AXyoBF;AWxoBE;EACE,mBAAA;EACA,gBAAA;AX0oBJ;AWxoBE;EACE,WAAA;EACA,oBAAA;KAAA,iBAAA;EACA,qBAAA;EACA,+BAAA;AX0oBJ;AWxoBE;EACE,mBAAA;EACA,+BAAA;AX0oBJ;AWxoBE;EACE,kBAAA;EACA,aAAA;AX0oBJ;AWzoBI;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AX2oBN;AWzoBI;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AX2oBN;AWzoBI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AX2oBN;;AIhrBE;EO0CF;;;;IAKI,aAAA;EXyoBF;AACF;;AYltBA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBVIc;EUHd,cVNgB;EUOhB,6BAAA;EAAA,qBAAA;EACA,gBAAA;EACA,iBAAA;AZqtBF;AYptBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;AZstBJ;AI7sBE;EQdA;IAQI,cAAA;EZutBJ;AACF;AYrtBE;EACE,cAAA;AZutBJ;;AYntBA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AZstBF;AYrtBE;EACE;IACE,yBVzBe;IU0Bf,cVnCa;IUoCb,6CAAA;EZutBJ;AACF;;AYntBA;EAEE,iBAAA;EACA,gBAAA;EACA,cAAA;AZqtBF;;AYltBA;;EAEE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cV1DgB;EU2DhB,6BAAA;EAAA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AZqtBF;AYptBE;;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aVnEc;AF0xBlB;AYrtBE;EACE;;IACE,yBV3De;IU4Df,cVrEa;IUsEb,6CAAA;EZwtBJ;EYttBE;;IACE,aVzEa;EFkyBjB;AACF;;AYrtBA;EACE,eAAA;EAEA,qBVlEmB;AFyxBrB;AYttBE;EACE;IACE,yBV9EU;IU+EV,cVxFY;IUyFZ,6CAAA;EZwtBJ;EYttBE;IACE,iBAAA;EZwtBJ;AACF;;AYptBA;EACE,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EAAA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cV9GgB;EU+GhB,yBVtGc;EUuGd,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AZutBF;AYrtBE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,yBVpGiB;AF2zBrB;AYptBE;EACE,yBVrGgB;EUsGhB,cVlHY;EUmHZ,6CAAA;AZstBJ;AYptBE;EACE,yBV1GgB;EU2GhB,cVvHY;AF60BhB;AYntBE;EACE,sBAAA;AZqtBJ;;AYjtBA;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBVnIc;EUoId,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,cVhJgB;AFo2BlB;AYltBE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBVzJc;EU0Jd,oBAAA;EACA,yBAAA;EACA,gCAAA;AZotBJ;AYjtBE;EACE,oBAAA;EACA,yBAAA;AZmtBJ;;AY/sBA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AZktBF;;AY/sBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AZktBF;AYhtBE;EACE,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,WAAA;EACA,WAAA;EACA,yBV9Lc;EU+Ld,6EAAA;AZktBJ;AY/sBE;EACE,QAAA;EACA,UAAA;AZitBJ;AY9sBE;EACE,WAAA;EACA,UAAA;AZgtBJ;;Aa35BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;Ab85BF;Aa55BE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;Ab85BJ;;Aa15BA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;Ab65BF;Aa55BE;EACE,gBAAA;Ab85BJ;AI35BE;ESJA;IAGI,cAAA;IACA,YAAA;Ebg6BJ;AACF;Aa75BI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;Ab+5BN;Aa75BI;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;Ab+5BN;Aa75BI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;Ab+5BN;Aa55BE;EAEE,cAAA;Ab65BJ;Aa35BE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;Ab65BJ;;Aaz5BA;EACE,WAAA;EACA,WAAA;EACA,yBX/CmB;EWgDnB,sBAAA;Ab45BF;;Aaz5BA;EACE,yBXtEgB;EWuEhB,4CAAA;Ab45BF;;Aaz5BA;EACE;IACE,oBAAA;IACA,uBAAA;Eb45BF;Eaz5BA;IACE,oBAAA;IACA,uBAAA;Eb25BF;AACF;Aax5BA;EACE,4BAAA;Ab05BF;;Aav5BA;EACE,6BAAA;EACA,4BAAA;Ab05BF;;Aav5BA;EACE,4BAAA;EACA,4BAAA;Ab05BF;;Aav5BA;EACE,6BAAA;Ab05BF;;Aav5BA;EACE;IACE,OAAA;Eb05BF;Eax5BA;IACE,WAAA;Eb05BF;AACF;Aav5BA;EACE;IACE,UAAA;Eby5BF;Eav5BA;IACE,OAAA;Eby5BF;AACF;AcjhCE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;AdmhCJ;AcjhCI;EACE,SAAA;EACA,UAAA;EACA,SAAA;AdmhCN;AcjhCM;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AdmhCR;AcjhCQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AdmhCV;Ac/gCI;EACE,6BAAA;EAAA,qBAAA;EACA,cZhCY;EYiCZ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AdihCN;Ac9gCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBZ9CY;EY+CZ,oBAAA;EACA,yBAAA;EACA,gCAAA;AdghCN;Ac7gCI;EACE;IACE,oBAAA;IACA,yBAAA;Ed+gCN;AACF;Ac3gCE;EACE,SAAA;Ad6gCJ;AczgCI;EACE,yCAAA;EACA,6EAAA;Ad2gCN;AcvgCI;EACE,yCAAA;EACA,6EAAA;AdygCN;;AeplCA;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,cAAA;EACA,qCAAA;AfulCF;AerlCE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBbTY;AFgmChB;AeplCE;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AfslCJ;AenlCE;EACE,qBAAA;EACA,uBAAA;AfqlCJ;AenlCI;EACE,aAAA;AfqlCN;AejlCE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AfmlCJ;AehlCE;EACE,iBAAA;EACA,sBAAA;AfklCJ;Ae/kCE;EACE,qBAAA;AfilCJ;Ae9kCE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;AfglCJ;Ae7kCE;EACE,WAAA;Af+kCJ;Ae5kCE;EACE,6BAAA;EACA,kBAAA;Af8kCJ;Ae3kCE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Af6kCJ;Ae1kCE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBblEiB;EamEjB,yBAAA;Af4kCJ;AezkCE;EACE,WAAA;EACA,sBAAA;Af2kCJ;AezkCI;EACE,qBAAA;Af2kCN;AevkCE;EACE,qBAAA;AfykCJ;AetkCE;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBbnGY;EaoGZ,kBAAA;AfwkCJ;AetkCI;EACE;IACE,yBbrGa;IasGb,cb/GW;IagHX,6CAAA;EfwkCN;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(https://fonts.googleapis.com/css?family=Inter:100,200,300,regular,500,600,700,800,900&display=swap);\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n}\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n[hidden],\ntemplate {\n  display: none;\n}\n\nhtml {\n  background: #e1d4c9;\n  color: #403f3d;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: \"Inter\", sans-serif;\n}\n\nbody {\n  margin: 0;\n}\n\na {\n  background: transparent;\n}\na:focus {\n  outline: thin dotted;\n}\na:hover, a:active {\n  outline: 0;\n}\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\nh2 {\n  font-size: 1.5em;\n  margin: 0.83em 0;\n}\n\nh3 {\n  font-size: 1.17em;\n  margin: 1em 0;\n}\n\nh4 {\n  font-size: 1em;\n  margin: 1.33em 0;\n}\n\nh5 {\n  font-size: 0.83em;\n  margin: 1.67em 0;\n}\n\nh6 {\n  font-size: 0.75em;\n  margin: 2.33em 0;\n}\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\ndfn {\n  font-style: italic;\n}\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, serif;\n  font-size: 1em;\n}\n\npre {\n  white-space: pre;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\nq {\n  quotes: \"“\" \"”\" \"‘\" \"’\";\n}\n\nq:before, q:after {\n  content: \"\";\n  content: none;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nimg {\n  border: 0;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\nfigure {\n  margin: 0;\n}\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\nlegend {\n  border: 0;\n  padding: 0;\n  white-space: normal;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 100%;\n  margin: 0;\n  vertical-align: baseline;\n}\n\nbutton,\ninput {\n  line-height: normal;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml input[type=button],\ninput[type=reset],\ninput[type=submit] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled],\ninput[disabled] {\n  cursor: default;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=search] {\n  -webkit-appearance: textfield;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\ninput[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\ninput[type=checkbox], input[type=radio] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.hidden {\n  position: absolute;\n  left: -99999em;\n  width: 1px;\n  height: 1px;\n}\n\n@media (max-width: 769px) {\n  .hide-for-mobile {\n    display: none !important;\n  }\n}\n\n@media (min-width: 769px) {\n  .hide-for-desktop {\n    display: none !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .hide-for-phones {\n    display: none !important;\n  }\n}\n\n.container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 20px 0 40px;\n  width: 100%;\n}\n\nh2 {\n  margin: 0;\n}\n\n.section-visible {\n  display: block;\n  padding: 0 40px 100px 40px;\n}\n@media (max-width: 576px) {\n  .section-visible {\n    padding: 0 16px 100px 16px;\n  }\n}\n\n.section-hidden {\n  display: none;\n}\n\nli {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.flex {\n  display: flex;\n}\n.flex-fd-row {\n  flex-direction: row;\n}\n.flex-fd-column {\n  flex-direction: column;\n}\n.flex-fw-wrap {\n  flex-wrap: wrap;\n}\n.flex-jc-center {\n  justify-content: center;\n}\n.flex-jc-start {\n  justify-content: flex-start;\n}\n.flex-jc-space-between {\n  justify-content: space-between;\n}\n.flex-ai-center {\n  align-items: center;\n}\n.flex-as-stretch {\n  align-self: stretch;\n}\n\n.highlight {\n  color: #b0907a;\n  font-style: italic;\n}\n\n.small-text {\n  font-size: 0.625rem;\n  font-weight: 600;\n  line-height: 140%;\n}\n\n.title {\n  font-size: 3.75rem;\n  font-weight: 600;\n  line-height: 125%;\n}\n@media (max-width: 576px) {\n  .title {\n    font-size: 2rem;\n  }\n}\n\n.about_title {\n  margin-block-start: 0;\n  margin-block-end: 0;\n}\n@media (max-width: 992px) {\n  .about_title {\n    margin-bottom: 40px;\n  }\n}\n\n.about_fotos_container {\n  gap: 40px;\n}\n@media (max-width: 992px) {\n  .about_fotos_container {\n    flex-direction: column;\n  }\n}\n.about_fotos_container .about-item_column {\n  flex: 1;\n  box-sizing: border-box;\n}\n.about_fotos_container .about-item_column .about-item_image {\n  border-radius: 20px;\n  margin-top: 38px;\n  overflow: hidden;\n}\n@media (max-width: 992px) {\n  .about_fotos_container .about-item_column .about-item_image {\n    height: 590px;\n    margin-top: 0;\n  }\n}\n.about_fotos_container .about-item_column .about-item_image img {\n  width: 100%;\n  object-fit: cover;\n  transform: scale(1.2);\n  transition: transform 0.6s ease;\n}\n@media (max-width: 576px) {\n  .about_fotos_container .about-item_column .about-item_image img {\n    width: max-content;\n    margin-left: 50%;\n    transform: translateX(-50%);\n  }\n}\n.about_fotos_container .about-item_column .about-item_image:hover img {\n  transform: scale(1);\n  transition: transform 0.6s ease;\n}\n\n#image3 {\n  height: 430px;\n}\n\n@media (max-width: 992px) {\n  #second-image,\n  #third-image {\n    display: none;\n  }\n}\n\n.header {\n  padding: 0 40px 20px 40px;\n}\n@media (max-width: 576px) {\n  .header {\n    padding: 0 16px 20px 16px;\n  }\n}\n.header__nav a {\n  position: relative;\n  text-decoration: none;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 50%;\n  color: #403f3d;\n}\n.header__links {\n  padding: 0 0;\n  gap: 40px;\n  margin-top: 12px;\n  margin-left: 8px;\n}\n.header__links a::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #403f3d;\n  transform: scaleX(0);\n  transform-origin: 50% 50%;\n  transition: transform 350ms ease;\n}\n.header__links a:hover::after {\n  transform: scaleX(1);\n  transform-origin: 50% 50%;\n}\n.header__menu {\n  padding-right: 30px;\n  margin-bottom: 4px;\n}\n\n.footer {\n  margin: 0 40px;\n  padding: 100px;\n  border-radius: 40px;\n  background: #665f55;\n  color: #e1d4c9;\n  gap: 100px;\n}\n@media (max-width: 992px) {\n  .footer {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 100px 60px;\n    gap: 100px;\n  }\n}\n@media (max-width: 576px) {\n  .footer {\n    margin: 0 16px;\n    padding: 60px 16px;\n    gap: 35px;\n  }\n}\n.footer .footer__title {\n  margin-bottom: 32px;\n  max-width: 530px;\n}\n@media (max-width: 992px) {\n  .footer .footer__title {\n    margin-bottom: 40px;\n  }\n}\n.footer .footer-social {\n  flex-basis: 50% !important;\n}\n.footer .footer-icons__container {\n  gap: 12px;\n}\n.footer .footer-contacts__title {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 125%;\n}\n.footer .footer__list {\n  padding: 0;\n}\n.footer .footer__item {\n  position: relative;\n  padding: 20px 0 0;\n  border-bottom: 2px solid transparent;\n}\n.footer .footer__item img {\n  padding-right: 4px;\n}\n.footer .footer__item a {\n  text-decoration: none;\n  color: #e1d4c9;\n}\n.footer .footer__item a::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 70%;\n  height: 2px;\n  background: #e1d4c9;\n  transform: scaleX(0);\n  transform-origin: 50% 50%;\n  transition: transform 450ms ease;\n}\n.footer .footer__item a:hover::after {\n  transform: scaleX(1);\n  transform-origin: 50% 50%;\n}\n\n.start-screen {\n  position: relative;\n}\n.start-screen_background {\n  position: absolute;\n  width: 100%;\n  height: 644px;\n  object-fit: cover;\n  border-radius: 40px;\n  z-index: -1;\n}\n@media (max-width: 769px) {\n  .start-screen_background {\n    height: 100%;\n  }\n}\n.start-screen_content {\n  padding: 100px 100px;\n  max-width: 530px;\n  color: #e1d4c9;\n}\n@media (max-width: 1200px) {\n  .start-screen_content {\n    padding: 100px 60px;\n  }\n}\n@media (max-width: 576px) {\n  .start-screen_content {\n    padding: 60px 16px;\n  }\n}\n.start-screen_content .start-screen_title {\n  font-size: 4.5rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 106%;\n}\n@media (max-width: 576px) {\n  .start-screen_content .start-screen_title {\n    font-size: 2.625rem;\n    line-height: 115%;\n  }\n}\n.start-screen_content .start-screen_subtitle {\n  font-weight: 400;\n  line-height: 150%;\n  padding: 23px 0 44px;\n}\n\n#favcoffee {\n  position: relative;\n  height: 50rem;\n}\n@media (max-width: 992px) {\n  #favcoffee {\n    height: 56rem;\n  }\n}\n@media (max-width: 576px) {\n  #favcoffee {\n    height: 40rem;\n  }\n}\n\n.favcoffee_title {\n  text-align: center;\n}\n\n.mobile-app_container {\n  gap: 100px;\n}\n@media (max-width: 1200px) {\n  .mobile-app_container {\n    flex-direction: column;\n    gap: 90px;\n  }\n}\n@media (max-width: 576px) {\n  .mobile-app_container {\n    gap: 30px;\n  }\n}\n.mobile-app_container .mobile-app_offer {\n  gap: 40px;\n  margin-bottom: 12px;\n}\n.mobile-app_container .mobile-app_offer .mobile-app_title {\n  margin-block-start: 0;\n  margin-block-end: 0;\n  padding-top: 0px;\n}\n.mobile-app_container .mobile-app_offer .mobile-app_subtitle {\n  font-weight: 400;\n  line-height: 150%;\n  padding-top: 0px;\n  margin: 0;\n}\n.mobile-app_container .mobile-app_offer .mobile-app_buttons {\n  gap: 20px;\n  padding-top: 0px;\n}\n@media (max-width: 576px) {\n  .mobile-app_container .mobile-app_offer .mobile-app_buttons {\n    flex-direction: column;\n  }\n}\n@media (max-width: 576px) {\n  .mobile-app_container .mobile-app_screens img {\n    width: 348px;\n  }\n}\n\n.menu_card-container {\n  gap: 37px;\n}\n@media (max-width: 769px) {\n  .menu_card-container {\n    padding-bottom: 40px;\n  }\n}\n\n.menu_title {\n  margin: 0 290px;\n  text-align: center;\n}\n@media (max-width: 1200px) {\n  .menu_title {\n    margin: 0;\n  }\n}\n\n.menu_tabs {\n  gap: 16px;\n  padding: 40px 0;\n}\n\n.menu_card {\n  width: 310px;\n  height: 467px;\n  flex-shrink: 0;\n  padding-bottom: 40px;\n  border-radius: 40px;\n  border: 1px solid #c1b6ad;\n}\n.menu_card_img {\n  border-radius: 40px;\n  overflow: hidden;\n}\n.menu_card img {\n  width: 100%;\n  object-fit: cover;\n  transform: scale(1.1);\n  transition: transform 0.6s ease;\n}\n.menu_card:hover img {\n  transform: scale(1);\n  transition: transform 0.6s ease;\n}\n.menu_card .menu_card_content {\n  position: relative;\n  padding: 20px;\n}\n.menu_card .menu_card_content .menu_card_title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 110%;\n  margin: 0;\n}\n.menu_card .menu_card_content .menu_card_description {\n  line-height: 150%;\n  margin-top: 12px;\n  margin-bottom: 0;\n}\n.menu_card .menu_card_content .menu_card_price {\n  position: absolute;\n  top: 120px;\n  left: 20px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 125%;\n}\n\n@media (max-width: 992px) {\n  #coffee5,\n  #coffee6,\n  #coffee7,\n  #coffee8 {\n    display: none;\n  }\n}\n\n.btn-primary {\n  cursor: pointer;\n  position: relative;\n  width: 200px;\n  padding: 22px 78px;\n  border-radius: 100px;\n  background: #e1d4c9;\n  color: #403f3d;\n  text-decoration: none;\n  font-weight: 600;\n  line-height: 150%;\n}\n.btn-primary .start-screen_icon {\n  position: absolute;\n  right: 26%;\n  top: 50%;\n  transform: translateY(-50%);\n  display: none;\n}\n@media (max-width: 769px) {\n  .btn-primary .start-screen_icon {\n    display: block;\n  }\n}\n.btn-primary:hover .start-screen_icon {\n  display: block;\n}\n\n.btn__arrow, .btn-icon-light, .btn__refresh {\n  cursor: pointer;\n  border: 1px solid #665f55;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n@media (hover: hover) {\n  .btn__arrow:hover, .btn-icon-light:hover, .btn__refresh:hover {\n    background-color: #665f55;\n    color: #e1d4c9;\n    transition: background-color 0.5s ease-in-out;\n  }\n}\n\n.btn__refresh {\n  font-size: 1.4rem;\n  font-weight: 200;\n  margin: 0 auto;\n}\n\n.btn-app-store,\n.btn-google-play {\n  cursor: pointer;\n  width: 160px;\n  padding: 8px 19px;\n  align-items: center;\n  border: 1px solid #665f55;\n  color: #403f3d;\n  text-decoration: none;\n  font-weight: 600;\n  line-height: 140%;\n  border-radius: 100px;\n}\n.btn-app-store .btn_icon,\n.btn-google-play .btn_icon {\n  width: 36px;\n  height: 36px;\n  margin-right: 8px;\n  fill: #403f3d;\n}\n@media (hover: hover) {\n  .btn-app-store:hover,\n  .btn-google-play:hover {\n    background-color: #665f55;\n    color: #e1d4c9;\n    transition: background-color 0.6s ease-in-out;\n  }\n  .btn-app-store:hover .btn_icon,\n  .btn-google-play:hover .btn_icon {\n    fill: #e1d4c9;\n  }\n}\n\n.btn-icon-light {\n  cursor: pointer;\n  border-color: #c1b6ad;\n}\n@media (hover: hover) {\n  .btn-icon-light:hover {\n    background-color: #e1d4c9;\n    color: #403f3d;\n    transition: background-color 0.5s ease-in-out;\n  }\n  .btn-icon-light:hover img {\n    filter: invert(1);\n  }\n}\n\n.tab-item {\n  cursor: pointer;\n  display: inline-flex;\n  flex-direction: row-reverse;\n  padding: 8px 16px 8px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 100px;\n  border: 1px solid #c1b6ad;\n  text-decoration: none;\n  font-weight: 600;\n  line-height: 150%;\n  color: #403f3d;\n  background-color: #e1d4c9;\n  user-select: none;\n}\n.tab-item img {\n  border-radius: 100px;\n  border: 1px solid #c1b6ad;\n  padding: 3px;\n  background-color: #c1b6ad;\n}\n.tab-item:hover {\n  background-color: #665f55;\n  color: #e1d4c9;\n  transition: background-color 0.5s ease-in-out;\n}\n.tab-item-active {\n  background-color: #665f55;\n  color: #e1d4c9;\n}\n.tab-item-inactive {\n  background-color: #fff;\n}\n\n.link-with-icon {\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  background-color: #e1d4c9;\n  border: 1px solid transparent;\n  font-weight: 600;\n  line-height: 150%;\n  color: #403f3d;\n}\n.link-with-icon::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #403f3d;\n  transform: scaleX(0);\n  transform-origin: 50% 50%;\n  transition: transform 350ms ease;\n}\n.link-with-icon:hover::after {\n  transform: scaleX(1);\n  transform-origin: 50% 50%;\n}\n\n.icon {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.header__burger {\n  display: flex;\n  width: 44px;\n  height: 44px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border: 1px solid #665f55;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n}\n.header__burger span {\n  display: block;\n  position: absolute;\n  transition: transform 0.3s ease;\n  width: 16px;\n  height: 2px;\n  background-color: #403f3d;\n  transition: transform 2s ease-in-out, top 2s ease-in-out, left 2s ease-in-out;\n}\n.header__burger span:first-child {\n  top: 4px;\n  left: -8px;\n}\n.header__burger span:last-child {\n  bottom: 4px;\n  left: -8px;\n}\n\n.carousel {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 90%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}\n.carousel .slides-wrapper {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.slide-container {\n  display: none;\n  position: relative;\n  margin: 0 auto;\n  width: 480px;\n  overflow: hidden;\n  animation: 1s ease-in-out;\n}\n.slide-container img {\n  max-width: 480px;\n}\n@media (max-width: 576px) {\n  .slide-container img {\n    margin: 0 auto;\n    width: 348px;\n  }\n}\n.slide-container .slide-content h3 {\n  font-size: 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 125%;\n  padding-top: 61px;\n  margin: 0px;\n}\n.slide-container .slide-content .slide-description {\n  text-align: center;\n  padding-top: 15px;\n  line-height: 150%;\n  margin: 0;\n}\n.slide-container .slide-content .slide-price {\n  font-size: 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 125%;\n  padding-top: 17px;\n  margin: 0px;\n}\n.slide-container.active, .slide-container.next {\n  display: block;\n}\n.slide-container.next {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.horizontal-line {\n  width: 40px;\n  height: 4px;\n  background-color: #c1b6ad;\n  margin: 39px 6px 0 6px;\n}\n\n.horizontal-line-active {\n  background-color: #403f3d;\n  animation: anim 7s ease 0s 1 normal forwards;\n}\n\n@keyframes anim {\n  0% {\n    transform: scaleX(0);\n    transform-origin: 0% 0%;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n  }\n}\n.animate_to-left {\n  animation-name: scrollToLeft;\n}\n\n.animate_to-right {\n  animation-name: scrollToRight;\n  animation-direction: reverse;\n}\n\n.animate_from-left {\n  animation-name: scrollToLeft;\n  animation-direction: reverse;\n}\n\n.animate_from-right {\n  animation-name: scrollToRight;\n}\n\n@keyframes scrollToLeft {\n  from {\n    left: 0;\n  }\n  to {\n    left: -100%;\n  }\n}\n@keyframes scrollToRight {\n  from {\n    left: 100%;\n  }\n  to {\n    left: 0;\n  }\n}\n.mobile__nav {\n  position: fixed;\n  margin-top: 20px;\n  padding: 60px 0px;\n  top: 78px;\n  left: 100%;\n  width: 100%;\n  min-height: 100vh;\n  display: block;\n  z-index: 5;\n  background-color: #e1d4c9;\n  transition: 2s;\n}\n.mobile__nav ul {\n  margin: 0;\n  padding: 0;\n  gap: 60px;\n}\n.mobile__nav ul a {\n  position: relative;\n  margin-top: 40px;\n  width: 140px;\n}\n.mobile__nav ul a img {\n  position: absolute;\n  top: -2px;\n  width: 30%;\n  padding-left: 14px;\n}\n.mobile__nav a {\n  text-decoration: none;\n  color: #403f3d;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 125%;\n}\n.mobile__nav a::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #403f3d;\n  transform: scaleX(0);\n  transform-origin: 50% 50%;\n  transition: transform 350ms ease;\n}\n@media (hover: hover) {\n  .mobile__nav a:hover::after {\n    transform: scaleX(1);\n    transform-origin: 50% 50%;\n  }\n}\n.mobile__nav-active {\n  left: 8px;\n}\n.mobile__btn-active span:first-child {\n  transform: translateY(-5px) rotate(45deg);\n  transition: transform 2s ease-in-out, top 2s ease-in-out, left 2s ease-in-out;\n}\n.mobile__btn-active span:last-child {\n  transform: translateY(5px) rotate(-45deg);\n  transition: transform 2s ease-in-out, top 2s ease-in-out, left 2s ease-in-out;\n}\n\n.modal {\n  z-index: 10;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n.modal-container {\n  position: fixed;\n  margin: 0 auto;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 48rem;\n  padding: 1rem;\n  border-radius: 2.5rem;\n  background-color: #e1d4c9;\n}\n.modal-image {\n  width: 19.35rem;\n  flex-shrink: 0;\n  border-radius: 2.5rem;\n}\n.modal-content {\n  padding-left: 1.25rem;\n  align-items: flex-start;\n}\n.modal-content p {\n  margin-top: 0;\n}\n.modal-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 125%;\n  margin: 0 0 0.7rem 0;\n}\n.modal-description {\n  line-height: 150%;\n  margin-bottom: 1.35rem;\n}\n.modal-label {\n  margin-bottom: 0.6rem;\n}\n.modal-label-total {\n  font-size: 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 125%;\n  margin-top: 0;\n  margin-bottom: 0.9rem;\n}\n.modal-total-wrapper {\n  width: 100%;\n}\n.modal-line {\n  border-top: 1px solid #c1b6ad;\n  padding: 0.75rem 0;\n}\n.modal-info-text {\n  font-size: 0.625rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 140%;\n}\n.modal-icon {\n  border-radius: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 3px;\n  justify-content: center;\n  align-items: center;\n  background-color: #c1b6ad;\n  border: 1px solid #c1b6ad;\n}\n.modal-buttons-group {\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n}\n.modal-buttons-group button {\n  padding-right: 0.8rem;\n}\n.modal-info-icon {\n  padding-right: 0.5rem;\n}\n.modal-close-button {\n  width: 100%;\n  padding: 10px 78px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  border: 1px solid #665f55;\n  background-color: #e1d4c9;\n  margin-top: 0.8rem;\n}\n@media (hover: hover) {\n  .modal-close-button:hover {\n    background-color: #665f55;\n    color: #e1d4c9;\n    transition: background-color 0.5s ease-in-out;\n  }\n}","// =============================================================================\n// Normalize.scss based on Nicolas Gallagher and Jonathan Neal's\n// normalize.css v2.1.3 | MIT License | git.io/normalize\n// =============================================================================\n\n// =============================================================================\n// Normalize.scss settings\n// =============================================================================\n\n// Set to true if you want to add support for IE6 and IE7\n// Notice: setting to true might render some elements\n// slightly differently than when set to false\n$legacy_support_for_ie: false !default; // Used also in Compass\n\n// Set the default font family here so you don't have to override it later\n$normalized_font_family: \"Inter\", sans-serif !default;\n\n$normalize_headings: true !default;\n\n$h1_font_size: 2em !default;\n$h2_font_size: 1.5em !default;\n$h3_font_size: 1.17em !default;\n$h4_font_size: 1em !default;\n$h5_font_size: 0.83em !default;\n$h6_font_size: 0.75em !default;\n\n$h1_margin: 0.67em 0 !default;\n$h2_margin: 0.83em 0 !default;\n$h3_margin: 1em 0 !default;\n$h4_margin: 1.33em 0 !default;\n$h5_margin: 1.67em 0 !default;\n$h6_margin: 2.33em 0 !default;\n\n$background: $bg-body-color !default;\n$color: $text-dark-color !default;\n\n// =============================================================================\n// HTML5 display definitions\n// =============================================================================\n\n// Corrects block display not defined in IE6/7/8/9 & FF3\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\n// Corrects inline-block display not defined in IE6/7/8/9 & FF3\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  @if $legacy_support_for_ie {\n    *display: inline;\n    *zoom: 1;\n  }\n}\n\n// 1. Prevents modern browsers from displaying 'audio' without controls\n// 2. Remove excess height in iOS5 devices\n\naudio:not([controls]) {\n  display: none; // 1\n  height: 0; // 2\n}\n\n//\n// Address `[hidden]` styling not present in IE 8/9.\n// Hide the `template` element in IE, Safari, and Firefox < 22.\n//\n\n[hidden],\ntemplate {\n  display: none;\n}\n\n// =============================================================================\n// Base\n// =============================================================================\n\n// 1. Corrects text resizing oddly in IE6/7 when body font-size is set using em units\n//    http://clagnut.com/blog/348/#c790\n// 2. Prevents iOS text size adjust after orientation change, without disabling user zoom\n//    www.456bereastreet.com/archive/201012/controlling_text_size_in_safari_for_ios_without_disabling_user_zoom/\n\nhtml {\n  @if $legacy_support_for_ie {\n    font-size: 100%; // 1\n  }\n  background: $background;\n  color: $color;\n  -webkit-text-size-adjust: 100%; // 2\n  -ms-text-size-adjust: 100%; // 2\n}\n\n// Addresses font-family inconsistency between 'textarea' and other form elements.\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: $normalized_font_family;\n}\n\n// Addresses margins handled incorrectly in IE6/7\n\nbody {\n  margin: 0;\n}\n\n// =============================================================================\n// Links\n// =============================================================================\n\n// 1. Remove the gray background color from active links in IE 10.\n// 2. Addresses outline displayed oddly in Chrome\n// 3. Improves readability when focused and also mouse hovered in all browsers\n//    people.opera.com/patrickl/experiments/keyboard/test\n\na {\n  // 1\n\n  background: transparent;\n\n  // 2\n\n  &:focus {\n    outline: thin dotted;\n  }\n\n  // 3\n\n  &:hover,\n  &:active {\n    outline: 0;\n  }\n}\n\n// =============================================================================\n// Typography\n// =============================================================================\n\n// Addresses font sizes and margins set differently in IE6/7\n// Addresses font sizes within 'section' and 'article' in FF4+, Chrome, S5\n\n@if $normalize_headings == true {\n  h1 {\n    font-size: $h1_font_size;\n    margin: $h1_margin;\n  }\n\n  h2 {\n    font-size: $h2_font_size;\n    margin: $h2_margin;\n  }\n\n  h3 {\n    font-size: $h3_font_size;\n    margin: $h3_margin;\n  }\n\n  h4 {\n    font-size: $h4_font_size;\n    margin: $h4_margin;\n  }\n\n  h5 {\n    font-size: $h5_font_size;\n    margin: $h5_margin;\n  }\n\n  h6 {\n    font-size: $h6_font_size;\n    margin: $h6_margin;\n  }\n}\n\n// Addresses styling not present in IE 8/9, S5, Chrome\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\n// Addresses style set to 'bolder' in FF3+, S4/5, Chrome\n\nb,\nstrong {\n  font-weight: bold;\n}\n\n@if $legacy_support_for_ie {\n  blockquote {\n    margin: 1em 40px;\n  }\n}\n\n// Addresses styling not present in S5, Chrome\n\ndfn {\n  font-style: italic;\n}\n\n// Addresses styling not present in IE6/7/8/9\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\n// Addresses margins set differently in IE6/7\n@if $legacy_support_for_ie {\n  p,\n  pre {\n    margin: 1em 0;\n  }\n}\n\n// Corrects font family set oddly in IE6, S4/5, Chrome\n// en.wikipedia.org/wiki/User:Davidgothberg/Test59\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, serif;\n  @if $legacy_support_for_ie {\n    _font-family: \"courier new\", monospace;\n  }\n  font-size: 1em;\n}\n\n// Improves readability of pre-formatted text in all browsers\n\npre {\n  white-space: pre;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n// Set consistent quote types.\n\nq {\n  quotes: \"\\201C\"\"\\201D\"\"\\2018\"\"\\2019\";\n}\n\n// 1. Addresses CSS quotes not supported in IE6/7\n// 2. Addresses quote property not supported in S4\n\n// 1\n@if $legacy_support_for_ie {\n  q {\n    quotes: none;\n  }\n}\n\n// 2\nq {\n  &:before,\n  &:after {\n    content: \"\";\n    content: none;\n  }\n}\n\n// Address inconsistent and variable font size in all browsers.\n\nsmall {\n  font-size: 80%;\n}\n\n// Prevents sub and sup affecting line-height in all browsers\n// gist.github.com/413930\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\n// =============================================================================\n// Lists\n// =============================================================================\n\n// Addresses margins set differently in IE6/7\n@if $legacy_support_for_ie {\n  dl,\n  menu,\n  ol,\n  ul {\n    margin: 1em 0;\n  }\n}\n\n@if $legacy_support_for_ie {\n  dd {\n    margin: 0 0 0 40px;\n  }\n}\n\n// Addresses paddings set differently in IE6/7\n@if $legacy_support_for_ie {\n  menu,\n  ol,\n  ul {\n    padding: 0 0 0 40px;\n  }\n}\n\n// Corrects list images handled incorrectly in IE7\n\nnav {\n  ul,\n  ol {\n    @if $legacy_support_for_ie {\n      list-style-image: none;\n    }\n  }\n}\n\n// =============================================================================\n// Embedded content\n// =============================================================================\n\n// 1. Removes border when inside 'a' element in IE6/7/8/9, FF3\n// 2. Improves image quality when scaled in IE7\n//    code.flickr.com/blog/2008/11/12/on-ui-quality-the-little-things-client-side-image-resizing/\n\nimg {\n  border: 0; // 1\n  @if $legacy_support_for_ie {\n    -ms-interpolation-mode: bicubic; // 2\n  }\n}\n\n// Corrects overflow displayed oddly in IE9\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n// =============================================================================\n// Figures\n// =============================================================================\n\n// Addresses margin not present in IE6/7/8/9, S5, O11\n\nfigure {\n  margin: 0;\n}\n\n// =============================================================================\n// Forms\n// =============================================================================\n\n// Corrects margin displayed oddly in IE6/7\n@if $legacy_support_for_ie {\n  form {\n    margin: 0;\n  }\n}\n\n// Define consistent border, margin, and padding\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n// 1. Corrects color not being inherited in IE6/7/8/9\n// 2. Remove padding so people aren't caught out if they zero out fieldsets.\n// 3. Corrects text not wrapping in FF3\n// 4. Corrects alignment displayed oddly in IE6/7\n\nlegend {\n  border: 0; // 1\n  padding: 0; // 2\n  white-space: normal; // 3\n  @if $legacy_support_for_ie {\n    *margin-left: -7px; // 4\n  }\n}\n\n// 1. Correct font family not being inherited in all browsers.\n// 2. Corrects font size not being inherited in all browsers\n// 3. Addresses margins set differently in IE6/7, FF3+, S5, Chrome\n// 4. Improves appearance and consistency in all browsers\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit; // 1\n  font-size: 100%; // 2\n  margin: 0; // 3\n  vertical-align: baseline; // 4\n  @if $legacy_support_for_ie {\n    *vertical-align: middle; // 4\n  }\n}\n\n// Addresses FF3/4 setting line-height on 'input' using !important in the UA stylesheet\n\nbutton,\ninput {\n  line-height: normal;\n}\n\n// Address inconsistent `text-transform` inheritance for `button` and `select`.\n// All other form control elements do not inherit `text-transform` values.\n// Correct `button` style inheritance in Chrome, Safari 5+, and IE 8+.\n// Correct `select` style inheritance in Firefox 4+ and Opera.\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n// 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n//    and `video` controls\n// 2. Corrects inability to style clickable 'input' types in iOS\n// 3. Improves usability and consistency of cursor style between image-type\n//    'input' and others\n// 4. Removes inner spacing in IE7 without affecting normal text inputs\n//    Known issue: inner spacing remains in IE6\n\nbutton,\nhtml input[type=\"button\"], // 1\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n  cursor: pointer; // 3\n  @if $legacy_support_for_ie {\n    *overflow: visible; // 4\n  }\n}\n\n// Re-set default cursor for disabled elements\n\nbutton[disabled],\ninput[disabled] {\n  cursor: default;\n}\n\n// Removes inner padding and border in FF3+\n// www.sitepen.com/blog/2008/05/14/the-devils-in-the-details-fixing-dojos-toolbar-buttons/\n\nbutton,\ninput {\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n}\n\n// 1. Removes default vertical scrollbar in IE6/7/8/9\n// 2. Improves readability and alignment in all browsers\n\ntextarea {\n  overflow: auto; // 1\n  vertical-align: top; // 2\n}\n\n// =============================================================================\n// Tables\n// =============================================================================\n\n// Remove most spacing between table cells\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput {\n  // 1. Addresses appearance set to searchfield in S5, Chrome\n  // 2. Addresses box-sizing set to border-box in S5, Chrome (include -moz to future-proof)\n  &[type=\"search\"] {\n    -webkit-appearance: textfield; // 1\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box; // 2\n    box-sizing: content-box;\n\n    // Remove inner padding and search cancel button in Safari 5 and Chrome\n    // on OS X.\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-decoration {\n      -webkit-appearance: none;\n    }\n  }\n\n  // 1. Address box sizing set to `content-box` in IE 8/9/10.\n  // 2. Remove excess padding in IE 8/9/10.\n  // 3. Removes excess padding in IE7\n  //    Known issue: excess padding remains in IE6\n  &[type=\"checkbox\"],\n  &[type=\"radio\"] {\n    box-sizing: border-box; // 1\n    padding: 0; // 2\n    @if $legacy_support_for_ie {\n      *height: 13px; // 3\n      *width: 13px; // 3\n    }\n  }\n}\n","/// Colors\n/// @type Color\n$text-dark-color: #403f3d !default;\n\n/// @type Color\n$text-light-color: #e1d4c9 !default;\n\n/// @type Color\n$text-accent-color: #b0907a !default;\n\n/// @type Color\n$bg-body-color: #e1d4c9 !default;\n\n/// @type Color\n$bg-container-color: #665f55 !default;\n\n/// @type Color\n$bg-backdrop-color: rgba(64, 63, 61, 0.8) !default;\n\n/// @type Color\n$border-light-color: #c1b6ad !default;\n\n/// @type Color\n$border-dark-color: #665f55 !default;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1440px !default;\n\n/// Container's minimum width\n/// @type Length\n$min-width: 380px !default;\n\n/// Background image\n$background-img: \"assets/images/premium-coffe_background.jpeg\";\n","html {\n  scroll-behavior: smooth;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.hidden {\n  position: absolute;\n  left: -99999em;\n  width: 1px;\n  height: 1px;\n}\n\n.hide-for-mobile {\n  @include breakpoint-down(adjusted-medium) {\n    display: none !important;\n  }\n}\n\n.hide-for-desktop {\n  @include breakpoint-up(adjusted-medium) {\n    display: none !important;\n  }\n}\n\n.hide-for-phones {\n  @include breakpoint-down(small) {\n    display: none !important;\n  }\n}\n\n// Main content container\n.container {\n  max-width: $max-width;\n  margin: 0 auto;\n  padding: 20px 0 40px;\n  width: 100%;\n}\n\nh2 {\n  margin: 0;\n}\n\n.section-visible {\n  display: block;\n  padding: 0 40px 100px 40px;\n  @include breakpoint-down(small) {\n    padding: 0 16px 100px 16px;\n  }\n}\n\n.section-hidden {\n  display: none;\n}\n\nli {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.flex {\n  display: flex;\n\n  &-fd-row {\n    flex-direction: row;\n  }\n  &-fd-column {\n    flex-direction: column;\n  }\n  &-fw-wrap {\n    flex-wrap: wrap;\n  }\n  &-jc-center {\n    justify-content: center;\n  }\n  &-jc-start {\n    justify-content: flex-start;\n  }\n  &-jc-space-between {\n    justify-content: space-between;\n  }\n  &-ai-center {\n    align-items: center;\n  }\n  &-as-stretch {\n    align-self: stretch;\n  }\n}\n\n.highlight {\n  color: $text-accent-color;\n  font-style: italic;\n}\n\n.small-text {\n  font-size: 0.625rem;\n  font-weight: 600;\n  line-height: 140%;\n}\n\n.title {\n  font-size: 3.75rem;\n  font-weight: 600;\n  line-height: 125%;\n\n  @include breakpoint-down(small) {\n    font-size: 2rem;\n  }\n}\n","@media (min-width: $min-width) {\n}\n\n/// Breakpoints map\n$breakpoints-up: (\n  \"adjusted-medium\": 769px,\n  \"medium\": 992px,\n  \"large\": 1200px,\n  \"huge\": 1440px,\n) !default;\n\n$breakpoints-down: (\n  \"adjusted-small\": 381px,\n  \"small\": 576px,\n  \"adjusted-medium\": 769px,\n  \"medium\": 992px,\n  \"large\": 1200px,\n) !default;\n\n@mixin breakpoint-up($size) {\n  @media (min-width: map-get($breakpoints-up, $size)) {\n    @content;\n  }\n}\n\n@mixin breakpoint-down($size) {\n  @media (max-width: map-get($breakpoints-down, $size)) {\n    @content;\n  }\n}\n",".about_title {\n  margin-block-start: 0;\n  margin-block-end: 0;\n\n  @include breakpoint-down(medium) {\n    margin-bottom: 40px;\n  }\n}\n\n.about_fotos_container {\n  gap: 40px;\n\n  @include breakpoint-down(medium) {\n    flex-direction: column;\n  }\n\n  .about-item_column {\n    flex: 1;\n    box-sizing: border-box;\n    .about-item_image {\n      border-radius: 20px;\n      margin-top: 38px;\n      overflow: hidden;\n\n      @include breakpoint-down(medium) {\n        height: 590px;\n        margin-top: 0;\n      }\n      @include breakpoint-down(small) {\n      }\n\n      img {\n        width: 100%;\n        object-fit: cover;\n        transform: scale(1.2);\n        transition: transform 0.6s ease;\n        @include breakpoint-down(small) {\n          width: max-content;\n          margin-left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n      &:hover img {\n        transform: scale(1);\n        transition: transform 0.6s ease;\n      }\n    }\n  }\n}\n#image3 {\n  height: 430px;\n}\n\n#second-image,\n#third-image {\n  @include breakpoint-down(medium) {\n    display: none;\n  }\n}\n",".header {\n  padding: 0 40px 20px 40px;\n\n  @include breakpoint-down(small) {\n    padding: 0 16px 20px 16px;\n  }\n\n  &__nav {\n    a {\n      position: relative;\n      text-decoration: none;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 50%;\n      color: $text-dark-color;\n    }\n  }\n  &__links {\n    padding: 0 0;\n    gap: 40px;\n    margin-top: 12px;\n    margin-left: 8px;\n\n    a::after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      background: $text-dark-color;\n      transform: scaleX(0);\n      transform-origin: 50% 50%;\n      transition: transform 350ms ease;\n    }\n\n    a:hover::after {\n      transform: scaleX(1);\n      transform-origin: 50% 50%;\n    }\n  }\n  &__menu {\n    padding-right: 30px;\n    margin-bottom: 4px;\n  }\n}\n",".footer {\n  margin: 0 40px;\n  padding: 100px;\n  border-radius: 40px;\n  background: $bg-container-color;\n  color: $text-light-color;\n  gap: 100px;\n\n  @include breakpoint-down(medium) {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 100px 60px;\n    gap: 100px;\n  }\n  @include breakpoint-down(small) {\n    margin: 0 16px;\n    padding: 60px 16px;\n    gap: 35px;\n  }\n\n  .footer__title {\n    margin-bottom: 32px;\n    max-width: 530px;\n    @include breakpoint-down(medium) {\n      margin-bottom: 40px;\n    }\n  }\n\n  .footer-social {\n    flex-basis: 50% !important;\n  }\n\n  .footer-icons__container {\n    gap: 12px;\n  }\n\n  .footer-contacts__title {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n    line-height: 125%;\n  }\n\n  .footer__list {\n    padding: 0;\n  }\n\n  .footer__item {\n    position: relative;\n    padding: 20px 0 0;\n    border-bottom: 2px solid transparent;\n    img {\n      padding-right: 4px;\n    }\n    a {\n      text-decoration: none;\n      color: $text-light-color;\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 70%;\n        height: 2px;\n        background: $text-light-color;\n        transform: scaleX(0);\n        transform-origin: 50% 50%;\n        transition: transform 450ms ease;\n      }\n\n      &:hover::after {\n        transform: scaleX(1);\n        transform-origin: 50% 50%;\n      }\n    }\n  }\n}\n",".start-screen {\n  position: relative;\n  &_background {\n    position: absolute;\n    width: 100%;\n    height: 644px;\n    object-fit: cover;\n    border-radius: 40px;\n    z-index: -1;\n\n    @include breakpoint-down(adjusted-medium) {\n      height: 100%;\n    }\n  }\n  &_content {\n    padding: 100px 100px;\n    max-width: 530px;\n    color: $text-light-color;\n\n    @include breakpoint-down(large) {\n      padding: 100px 60px;\n    }\n    @include breakpoint-down(small) {\n      padding: 60px 16px;\n    }\n\n    .start-screen_title {\n      font-size: 4.5rem;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 106%;\n\n      @include breakpoint-down(small) {\n        font-size: 2.625rem;\n        line-height: 115%;\n      }\n    }\n    .start-screen_subtitle {\n      font-weight: 400;\n      line-height: 150%;\n      padding: 23px 0 44px;\n    }\n  }\n}\n","#favcoffee {\n  position: relative;\n  height: 50rem;\n\n  @include breakpoint-down(medium) {\n    height: 56rem;\n  }\n  @include breakpoint-down(small) {\n    height: 40rem;\n  }\n}\n\n.favcoffee_title {\n  text-align: center;\n}\n",".mobile-app_container {\n  gap: 100px;\n\n  @include breakpoint-down(large) {\n    flex-direction: column;\n    gap: 90px;\n  }\n  @include breakpoint-down(small) {\n    gap: 30px;\n  }\n\n  .mobile-app_offer {\n    gap: 40px;\n    margin-bottom: 12px;\n    .mobile-app_title {\n      margin-block-start: 0;\n      margin-block-end: 0;\n      padding-top: 0px;\n    }\n    .mobile-app_subtitle {\n      font-weight: 400;\n      line-height: 150%;\n      padding-top: 0px;\n      margin: 0;\n    }\n    .mobile-app_buttons {\n      gap: 20px;\n      padding-top: 0px;\n\n      @include breakpoint-down(small) {\n        flex-direction: column;\n      }\n    }\n  }\n\n  .mobile-app_screens {\n    img {\n      @include breakpoint-down(small) {\n        width: 348px;\n      }\n    }\n  }\n}\n",".menu_card-container {\n  gap: 37px;\n\n  @include breakpoint-down(adjusted-medium) {\n    padding-bottom: 40px;\n  }\n}\n\n.menu_title {\n  margin: 0 290px;\n  text-align: center;\n\n  @include breakpoint-down(large) {\n    margin: 0;\n  }\n}\n\n.menu_tabs {\n  gap: 16px;\n  padding: 40px 0;\n}\n\n.menu_card {\n  width: 310px;\n  height: 467px;\n  flex-shrink: 0;\n  padding-bottom: 40px;\n  border-radius: 40px;\n  border: 1px solid $border-light-color;\n  &_img {\n    border-radius: 40px;\n    overflow: hidden;\n  }\n  img {\n    width: 100%;\n    object-fit: cover;\n    transform: scale(1.1);\n    transition: transform 0.6s ease;\n  }\n  &:hover img {\n    transform: scale(1);\n    transition: transform 0.6s ease;\n  }\n  .menu_card_content {\n    position: relative;\n    padding: 20px;\n    .menu_card_title {\n      font-size: 1.5rem;\n      font-weight: 600;\n      line-height: 110%;\n      margin: 0;\n    }\n    .menu_card_description {\n      line-height: 150%;\n      margin-top: 12px;\n      margin-bottom: 0;\n    }\n    .menu_card_price {\n      position: absolute;\n      top: 120px;\n      left: 20px;\n      font-size: 1.5rem;\n      font-weight: 600;\n      line-height: 125%;\n    }\n  }\n}\n\n#coffee5,\n#coffee6,\n#coffee7,\n#coffee8 {\n  @include breakpoint-down(medium) {\n    display: none;\n  }\n}\n","// All styles related to the button component\n.btn-primary {\n  cursor: pointer;\n  position: relative;\n  width: 200px;\n  padding: 22px 78px;\n  border-radius: 100px;\n  background: $bg-body-color;\n  color: $text-dark-color;\n  text-decoration: none;\n  font-weight: 600;\n  line-height: 150%;\n  .start-screen_icon {\n    position: absolute;\n    right: 26%;\n    top: 50%;\n    transform: translateY(-50%);\n    display: none;\n\n    @include breakpoint-down(adjusted-medium) {\n      display: block;\n    }\n  }\n  &:hover .start-screen_icon {\n    display: block;\n  }\n}\n\n.btn__arrow {\n  cursor: pointer;\n  border: 1px solid $border-dark-color;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  @media (hover: hover) {\n    &:hover {\n      background-color: $bg-container-color;\n      color: $text-light-color;\n      transition: background-color 0.5s ease-in-out;\n    }\n  }\n}\n\n.btn__refresh {\n  @extend .btn__arrow;\n  font-size: 1.4rem;\n  font-weight: 200;\n  margin: 0 auto;\n}\n\n.btn-app-store,\n.btn-google-play {\n  cursor: pointer;\n  width: 160px;\n  padding: 8px 19px;\n  align-items: center;\n  border: 1px solid $border-dark-color;\n  color: $text-dark-color;\n  text-decoration: none;\n  font-weight: 600;\n  line-height: 140%;\n  border-radius: 100px;\n  .btn_icon {\n    width: 36px;\n    height: 36px;\n    margin-right: 8px;\n    fill: $text-dark-color;\n  }\n  @media (hover: hover) {\n    &:hover {\n      background-color: $bg-container-color;\n      color: $text-light-color;\n      transition: background-color 0.6s ease-in-out;\n    }\n    &:hover .btn_icon {\n      fill: $text-light-color;\n    }\n  }\n}\n\n.btn-icon-light {\n  cursor: pointer;\n  @extend .btn__arrow;\n  border-color: $border-light-color;\n  @media (hover: hover) {\n    &:hover {\n      background-color: $bg-body-color;\n      color: $text-dark-color;\n      transition: background-color 0.5s ease-in-out;\n    }\n    &:hover img {\n      filter: invert(1);\n    }\n  }\n}\n\n.tab-item {\n  cursor: pointer;\n  display: inline-flex;\n  flex-direction: row-reverse;\n  padding: 8px 16px 8px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 100px;\n  border: 1px solid $border-light-color;\n  text-decoration: none;\n  font-weight: 600;\n  line-height: 150%;\n  color: $text-dark-color;\n  background-color: $bg-body-color;\n  user-select: none;\n\n  img {\n    border-radius: 100px;\n    border: 1px solid $border-light-color;\n    padding: 3px;\n    background-color: $border-light-color;\n  }\n\n  &:hover {\n    background-color: $border-dark-color;\n    color: $bg-body-color;\n    transition: background-color 0.5s ease-in-out;\n  }\n  &-active {\n    background-color: $border-dark-color;\n    color: $bg-body-color;\n    // pointer-events: none;\n  }\n  &-inactive {\n    background-color: #fff;\n  }\n}\n\n.link-with-icon {\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  background-color: $bg-body-color;\n  border: 1px solid transparent;\n  font-weight: 600;\n  line-height: 150%;\n  color: $text-dark-color;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: $text-dark-color;\n    transform: scaleX(0);\n    transform-origin: 50% 50%;\n    transition: transform 350ms ease;\n  }\n\n  &:hover::after {\n    transform: scaleX(1);\n    transform-origin: 50% 50%;\n  }\n}\n\n.icon {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.header__burger {\n  display: flex;\n  width: 44px;\n  height: 44px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border: 1px solid $border-dark-color;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n\n  & span {\n    display: block;\n    position: absolute;\n    transition: transform 0.3s ease;\n    width: 16px;\n    height: 2px;\n    background-color: $text-dark-color;\n    transition: transform 2s ease-in-out, top 2s ease-in-out,\n      left 2s ease-in-out;\n  }\n  & span:first-child {\n    top: 4px;\n    left: -8px;\n  }\n\n  & span:last-child {\n    bottom: 4px;\n    left: -8px;\n  }\n}\n",".carousel {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 90%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n\n  .slides-wrapper {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n  }\n}\n\n.slide-container {\n  display: none;\n  position: relative;\n  margin: 0 auto;\n  width: 480px;\n  overflow: hidden;\n  animation: 1s ease-in-out;\n  img {\n    max-width: 480px;\n    @include breakpoint-down(small) {\n      margin: 0 auto;\n      width: 348px;\n    }\n  }\n  .slide-content {\n    h3 {\n      font-size: 1.5rem;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 125%;\n      padding-top: 61px;\n      margin: 0px;\n    }\n    .slide-description {\n      text-align: center;\n      padding-top: 15px;\n      line-height: 150%;\n      margin: 0;\n    }\n    .slide-price {\n      font-size: 1.5rem;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 125%;\n      padding-top: 17px;\n      margin: 0px;\n    }\n  }\n  &.active,\n  &.next {\n    display: block;\n  }\n  &.next {\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n}\n\n.horizontal-line {\n  width: 40px;\n  height: 4px;\n  background-color: $border-light-color;\n  margin: 39px 6px 0 6px;\n}\n\n.horizontal-line-active {\n  background-color: $text-dark-color;\n  animation: anim 7s ease 0s 1 normal forwards;\n}\n\n@keyframes anim {\n  0% {\n    transform: scaleX(0);\n    transform-origin: 0% 0%;\n  }\n\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n  }\n}\n\n.animate_to-left {\n  animation-name: scrollToLeft;\n}\n\n.animate_to-right {\n  animation-name: scrollToRight;\n  animation-direction: reverse;\n}\n\n.animate_from-left {\n  animation-name: scrollToLeft;\n  animation-direction: reverse;\n}\n\n.animate_from-right {\n  animation-name: scrollToRight;\n}\n\n@keyframes scrollToLeft {\n  from {\n    left: 0;\n  }\n  to {\n    left: -100%;\n  }\n}\n\n@keyframes scrollToRight {\n  from {\n    left: 100%;\n  }\n  to {\n    left: 0;\n  }\n}\n",".mobile {\n  &__nav {\n    position: fixed;\n    margin-top: 20px;\n    padding: 60px 0px;\n    top: 78px;\n    left: 100%;\n    width: 100%;\n    min-height: 100vh;\n    display: block;\n    z-index: 5;\n    background-color: $bg-body-color;\n    transition: 2s;\n\n    ul {\n      margin: 0;\n      padding: 0;\n      gap: 60px;\n\n      a {\n        position: relative;\n        margin-top: 40px;\n        width: 140px;\n\n        img {\n          position: absolute;\n          top: -2px;\n          width: 30%;\n          padding-left: 14px;\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $text-dark-color;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 125%;\n    }\n\n    a::after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      background: $text-dark-color;\n      transform: scaleX(0);\n      transform-origin: 50% 50%;\n      transition: transform 350ms ease;\n    }\n\n    @media (hover: hover) {\n      a:hover::after {\n        transform: scaleX(1);\n        transform-origin: 50% 50%;\n      }\n    }\n  }\n\n  &__nav-active {\n    left: 8px;\n  }\n\n  &__btn-active {\n    span:first-child {\n      transform: translateY(-5px) rotate(45deg);\n      transition: transform 2s ease-in-out, top 2s ease-in-out,\n        left 2s ease-in-out;\n    }\n\n    span:last-child {\n      transform: translateY(5px) rotate(-45deg);\n      transition: transform 2s ease-in-out, top 2s ease-in-out,\n        left 2s ease-in-out;\n    }\n  }\n}\n",".modal {\n  z-index: 10;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.75);\n\n  &-container {\n    position: fixed;\n    margin: 0 auto;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 48rem;\n    padding: 1rem;\n    border-radius: 2.5rem;\n    background-color: $bg-body-color;\n  }\n\n  &-image {\n    width: 19.35rem;\n    flex-shrink: 0;\n    border-radius: 2.5rem;\n  }\n\n  &-content {\n    padding-left: 1.25rem;\n    align-items: flex-start;\n\n    p {\n      margin-top: 0;\n    }\n  }\n\n  &-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    line-height: 125%;\n    margin: 0 0 0.7rem 0;\n  }\n\n  &-description {\n    line-height: 150%;\n    margin-bottom: 1.35rem;\n  }\n\n  &-label {\n    margin-bottom: 0.6rem;\n  }\n\n  &-label-total {\n    font-size: 1.5rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 125%;\n    margin-top: 0;\n    margin-bottom: 0.9rem;\n  }\n\n  &-total-wrapper {\n    width: 100%;\n  }\n\n  &-line {\n    border-top: 1px solid $border-light-color;\n    padding: 0.75rem 0;\n  }\n\n  &-info-text {\n    font-size: 0.625rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n  }\n\n  &-icon {\n    border-radius: 50%;\n    width: 1.5rem;\n    height: 1.5rem;\n    padding: 3px;\n    justify-content: center;\n    align-items: center;\n    background-color: $border-light-color;\n    border: 1px solid $border-light-color;\n  }\n\n  &-buttons-group {\n    gap: 0.5rem;\n    margin-bottom: 1.25rem;\n\n    button {\n      padding-right: 0.8rem;\n    }\n  }\n\n  &-info-icon {\n    padding-right: 0.5rem;\n  }\n\n  &-close-button {\n    width: 100%;\n    padding: 10px 78px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100px;\n    border: 1px solid $border-dark-color;\n    background-color: $bg-body-color;\n    margin-top: 0.8rem;\n\n    @media (hover: hover) {\n      &:hover {\n        background-color: $bg-container-color;\n        color: $text-light-color;\n        transition: background-color 0.5s ease-in-out;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
